(function () {
  'use strict';

  if (window.__sucursalCardStockReady) return;
  window.__sucursalCardStockReady = true;

  var STORAGE_KEY = 'sucursal_store';
  var refreshTimer = null;
  var requestCounter = 0;

  function getState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function normalizeId(value) {
    if (!value) return '';
    return String(value).split('/').pop();
  }

  function getCards() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '.product-card[data-product-id]'
      )
    );
  }

  function isGiftCard(card) {
    var link = card.querySelector(
      'a[href*="/products/"]'
    );

    if (!link) return false;

    var href = link.getAttribute('href') || '';

    return /\/products\/tarjetas-de-regalo(?:[/?#]|$)/i.test(
      href
    );
  }

  function getProductIdFromInventory(product) {
    return normalizeId(
      product.productId ||
      product.product_id ||
      product.id ||
      ''
    );
  }

  function getHandleFromCard(card) {
    var link = card.querySelector(
      'a[href*="/products/"]'
    );

    if (!link) return '';

    var href = link.getAttribute('href') || '';
    var match = href.match(
      /\/products\/([^/?#]+)/
    );

    return match ? match[1] : '';
  }

  function getHandleFromInventory(product) {
    return String(
      product.handle ||
      product.productHandle ||
      ''
    );
  }

  function rememberControl(control) {
    if (control.dataset.sucursalOriginalSaved === 'true') {
      return;
    }

    control.dataset.sucursalOriginalSaved = 'true';
    control.dataset.sucursalOriginalHtml =
      control.innerHTML;

    control.dataset.sucursalOriginalDisabled =
      control.disabled ? 'true' : 'false';

    control.dataset.sucursalOriginalAriaDisabled =
      control.getAttribute('aria-disabled') || '';

    control.dataset.sucursalOriginalHref =
      control.getAttribute('href') || '';

    control.dataset.sucursalOriginalAriaControls =
      control.getAttribute('aria-controls') || '';

    control.dataset.sucursalOriginalAriaHaspopup =
      control.getAttribute('aria-haspopup') || '';
  }

  function restoreControl(control) {
    if (
      control.dataset.sucursalOriginalSaved !== 'true'
    ) {
      return;
    }

    control.innerHTML =
      control.dataset.sucursalOriginalHtml;

    if (
      control.dataset.sucursalOriginalDisabled ===
      'true'
    ) {
      control.disabled = true;
    } else {
      control.disabled = false;
      control.removeAttribute('disabled');
    }

    if (
      control.dataset.sucursalOriginalAriaDisabled
    ) {
      control.setAttribute(
        'aria-disabled',
        control.dataset.sucursalOriginalAriaDisabled
      );
    } else {
      control.removeAttribute('aria-disabled');
    }

    if (control.dataset.sucursalOriginalHref) {
      control.setAttribute(
        'href',
        control.dataset.sucursalOriginalHref
      );
    } else {
      control.removeAttribute('href');
    }

    if (
      control.dataset.sucursalOriginalAriaControls
    ) {
      control.setAttribute(
        'aria-controls',
        control.dataset.sucursalOriginalAriaControls
      );
    } else {
      control.removeAttribute('aria-controls');
    }

    if (
      control.dataset.sucursalOriginalAriaHaspopup
    ) {
      control.setAttribute(
        'aria-haspopup',
        control.dataset.sucursalOriginalAriaHaspopup
      );
    } else {
      control.removeAttribute('aria-haspopup');
    }

    control.classList.remove(
      'is-sucursal-soldout-control'
    );
  }

  function getActionControls(card) {
    var controls = Array.prototype.slice.call(
      card.querySelectorAll(
        '.product-card__atc,' +
        '.product-card__list-atc,' +
        'button[name="add"]'
      )
    );

    /*
     * El mismo elemento puede coincidir con más de
     * un selector.
     */
    return controls.filter(function (
      control,
      index
    ) {
      return controls.indexOf(control) === index;
    });
  }

  function markSoldOut(card) {
    card.classList.add('is-sucursal-soldout');

    getActionControls(card).forEach(function (
      control
    ) {
      rememberControl(control);

      control.disabled = true;
      control.setAttribute(
        'aria-disabled',
        'true'
      );

      /*
       * Algunos botones para elegir opciones pueden
       * ser <a>.
       */
      control.removeAttribute('href');
      control.removeAttribute('aria-controls');
      control.removeAttribute('aria-haspopup');

      control.classList.add(
        'is-sucursal-soldout-control'
      );

      control.innerHTML =
        '<div class="btn__text flex gap-1 items-center">' +
          '<span class="product-card__atc-text product-card__action-text">' +
            '¡Pronto de vuelta!' +
          '</span>' +
        '</div>';
    });
  }

  function markAvailable(card) {
    card.classList.remove(
      'is-sucursal-soldout'
    );

    getActionControls(card).forEach(function (
      control
    ) {
      restoreControl(control);
    });
  }

  function productHasStock(product) {
    var variants =
      product && Array.isArray(product.variants)
        ? product.variants
        : [];

    if (!variants.length) {
      /*
       * Si el endpoint no devuelve variantes,
       * no marcamos agotado por seguridad.
       */
      return true;
    }

    return variants.some(function (variant) {
      return Number(variant.available || 0) > 0;
    });
  }

  function refreshCardStock() {
    var state = getState();

    if (!state || !state.id) {
      return Promise.resolve();
    }

    var cards = getCards().filter(function (card) {
      return !isGiftCard(card);
    });

    if (!cards.length) {
      return Promise.resolve();
    }

    var productIds = [];

    cards.forEach(function (card) {
      var id = normalizeId(
        card.getAttribute('data-product-id')
      );

      if (
        id &&
        productIds.indexOf(id) === -1
      ) {
        productIds.push(id);
      }
    });

    if (!productIds.length) {
      return Promise.resolve();
    }

    var thisRequest = ++requestCounter;

    return fetch(
      'https://sioconn.dislicores.com/poligonos/inventory' +
        '?locationId=' +
        encodeURIComponent(state.id) +
        '&productIds=' +
        encodeURIComponent(productIds.join(','))
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Error consultando inventario de sucursal'
          );
        }

        return response.json();
      })
      .then(function (products) {
        if (thisRequest !== requestCounter) {
          return;
        }

        if (!Array.isArray(products)) {
          return;
        }

        var byProductId = {};
        var byHandle = {};

        products.forEach(function (product) {
          var productId =
            getProductIdFromInventory(product);

          var handle =
            getHandleFromInventory(product);

          if (productId) {
            byProductId[productId] = product;
          }

          if (handle) {
            byHandle[handle] = product;
          }
        });

        cards.forEach(function (card) {
          if (!card.isConnected) return;

          var productId = normalizeId(
            card.getAttribute('data-product-id')
          );

          var handle =
            getHandleFromCard(card);

          var product =
            byProductId[productId] ||
            byHandle[handle];

          /*
           * Si el endpoint no devolvió ese producto,
           * no asumimos que está agotado.
           */
          if (!product) {
            return;
          }

          if (productHasStock(product)) {
            markAvailable(card);
          } else {
            markSoldOut(card);
          }
        });
      })
      .catch(function (error) {
        console.warn(
          '[Sucursal card stock]',
          error
        );
      });
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(
      refreshCardStock,
      typeof delay === 'number'
        ? delay
        : 120
    );
  }

  /*
   * Primera carga
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleRefresh(50);
      }
    );
  } else {
    scheduleRefresh(50);
  }

  /*
   * Cambio de sucursal.
   */
  document.addEventListener(
    'sucursal:changed',
    function () {
      scheduleRefresh(50);
    }
  );

  window.addEventListener(
    'branch:changed',
    function () {
      scheduleRefresh(120);
    }
  );

  /*
   * Facets / filtros.
   */
  document.addEventListener(
    'collection:rerendered',
    function () {
      scheduleRefresh(100);
    }
  );

  /*
   * Tabs.
   */
  document.addEventListener(
    'tabChange',
    function () {
      scheduleRefresh(100);
    }
  );

  /*
   * Predictive search, sliders, recomendaciones,
   * secciones AJAX, etc.
   */
  var observer = new MutationObserver(function (
    mutations
  ) {
    var foundProduct = mutations.some(function (
      mutation
    ) {
      return Array.prototype.some.call(
        mutation.addedNodes || [],
        function (node) {
          if (
            !node ||
            node.nodeType !==
              Node.ELEMENT_NODE
          ) {
            return false;
          }

          if (
            node.matches &&
            node.matches('.product-card[data-product-id]')
          ) {
            return true;
          }

          return Boolean(
            node.querySelector &&
            node.querySelector(
              '.product-card[data-product-id]'
            )
          );
        }
      );
    });

    if (foundProduct) {
      scheduleRefresh(120);
    }
  });

  function startObserver() {
    if (!document.body) return;

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startObserver
    );
  } else {
    startObserver();
  }

  /*
   * API pública por si algún componente necesita
   * solicitar una revisión manual.
   */
  window.SucursalCardStock = {
    refresh: refreshCardStock
  };
})();